
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const TermsOfService = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 py-16 md:py-20">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold mb-6">Terms of Service</h1>
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-600">Last updated: May 20, 2025</p>
              
              <h2 className="text-2xl font-bold mt-8 mb-4">1. Introduction</h2>
              <p>
                These Terms of Service ("Terms") govern your use of the Spharaka Networks Private Limited website, platform, and services (collectively, the "Services") operated by Spharaka Networks Private Limited ("we," "us," or "our"). By accessing or using our Services, you agree to be bound by these Terms. If you disagree with any part of the Terms, you may not access the Services.
              </p>
              
              <h2 className="text-2xl font-bold mt-8 mb-4">2. Use of Services</h2>
              <p>
                Our Services are intended for business and professional use. You agree to use our Services only for lawful purposes and in accordance with these Terms. You agree not to:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Use our Services in any way that violates any applicable federal, state, local, or international law or regulation</li>
                <li>Attempt to probe, scan, or test the vulnerability of our systems or networks or breach any security or authentication measures</li>
                <li>Interfere with or disrupt the integrity or performance of the Services or third-party data contained therein</li>
                <li>Attempt to access, search, or create accounts for the Services by any means other than our publicly supported interfaces</li>
              </ul>
              
              <h2 className="text-2xl font-bold mt-8 mb-4">3. Intellectual Property</h2>
              <p>
                The Services and its original content, features, and functionality are and will remain the exclusive property of Spharaka Networks Private Limited and its licensors. The Services are protected by copyright, trademark, and other laws of both the United States and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Spharaka Networks Private Limited.
              </p>
              
              <h2 className="text-2xl font-bold mt-8 mb-4">4. Subscription and Payment</h2>
              <p>
                Some of our Services require payment and subscription. By subscribing to our Services, you agree to pay all fees associated with your subscription plan. We may change our fees at any time by posting the changes on our site or by notifying you directly.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">5. Limitation of Liability</h2>
              <p>
                In no event shall Spharaka Networks Private Limited, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Services.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">6. Indemnification</h2>
              <p>
                You agree to defend, indemnify, and hold harmless Spharaka Networks Private Limited, its parent, subsidiaries, affiliates, and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms or your use of the Services.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">7. Changes to Terms</h2>
              <p>
                We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">8. Contact Us</h2>
              <p>
                If you have any questions about these Terms, please contact us at contact@spharaka.com.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
